import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Fetch leaderboard data
 * @param {Object} params - Query parameters
 * @param {string} params.type - Leaderboard type: 'all', 'week', or 'month'
 * @param {string} [params.topicId] - Optional topic ID to filter by
 * @returns {Promise<Object>} Leaderboard response with entries, totalUsers, etc.
 */
export const fetchLeaderboard = async (params = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== "" && value != null
      )
    );

    const queryString = Object.entries(filteredParams)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const url = `${BASE_URL}/leaderboard${queryString ? `?${queryString}` : ""}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching leaderboard:", error);
    throw error;
  }
};
